import { SETAUTHOR, SETCATEGORY, SETKEYWORD } from './actionTypes'


export const allPostByCategory = (category) => {
    return {
        type: SETCATEGORY,
        payload: category
    }
}
export const allPostByAuthor = (author) => {
    return {
        type: SETAUTHOR,
        payload: author
    }
}
export const allPostByKeyword = (keyword) => {
    return {
        type: SETKEYWORD,
        payload: keyword
    }
}